import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_auth/admin/results/$id/edit")({
  parseParams(params) {
    return z.object({ id: z.string() }).parse(params);
  },
});
